import getMarkdocModel from "../../getters/markdocModel";

export const plantUml = getMarkdocModel("Plant-uml");
